import requester from '@/lib/axios';
import { Objective } from '@/models/CoursePath';
import { ListCoursePathFilters } from './coursePathServices';
import JsonApiResponse from '@/models/JsonApiResponse';

export async function getCoursePathObjective(
  slug: string,
  objectiveId: number,
) {
  const { data } = await requester().get<Objective>(
    `courses/${slug}/objectives/${objectiveId}/`,
  );

  return data;
}

export async function listCoursePathObjectives(
  slug: string,
  params: ListCoursePathFilters = {},
) {
  const { data } = await requester().get<JsonApiResponse<Objective>>(
    `courses/${slug}/objectives/`,
    {
      params,
    },
  );

  return data;
}

export async function createCoursePathObjective(
  slug: string,
  field: Partial<Objective>,
) {
  const { data } = await requester().post<Objective>(
    `courses/${slug}/objectives/`,
    field,
  );

  return data;
}

export async function updateCoursePathObjective(
  slug: string,
  objectiveId: number,
  field: Partial<Objective>,
) {
  const { data } = await requester().patch<Objective>(
    `courses/${slug}/objectives/${objectiveId}/`,
    field,
  );

  return data;
}

export async function deleteCoursePathObjective(
  slug: string,
  objectiveId: number,
) {
  await requester().delete<Objective>(
    `courses/${slug}/objectives/${objectiveId}/`,
  );
}
